import { z } from 'zod'

export const COACHING_YPO_LIFECYCLE_CONTRACT_VERSION = '1.0.0' as const
export const coachingYpoLifecycleResponseSchema = z.unknown()
export type CoachingYpoLifecycleResponse = z.infer<typeof coachingYpoLifecycleResponseSchema>
